import { useEffect, useState } from "react";
import ExcelJS from 'exceljs';
import Swal from 'sweetalert2';
import dayjs from 'dayjs';
import { commonToken, virtualPath } from "../../Config";

let baseUrl;
if (window.location.hostname.indexOf("react.") >= 0) {
    baseUrl = `${window.location.protocol}//${window.location.host}/${window.location.pathname.split('/')[1]}`;
} else {
    baseUrl = `${window.location.protocol}//${window.location.host}`;
}
export const API_SERVER = baseUrl;


export const ApiCall = (url, bodyData) => {
    let payloadData = {
        ...bodyData,
        Token : commonToken,
        Source: "Web",
        LoginToken: getCookie('login_Token'),
        LoginUserCode: getCookie('login_User_Code'),
    }
    const abortController = new AbortController();
    let data = fetch(`${API_SERVER + url}`, {
        method: "POST",
        body: JSON.stringify(payloadData),
        headers: {
            "Content-Type": "application/json"
        },
        signal: abortController.signal
    }).then((res) => res.json())
        .then((res) => {

            return res;
        })
        .catch((err) => {
            return err
        }).finally(() => {
            abortController.abort();
        });
    return data
};

export const FetchAutoCompleteData = async (type, prefix, contextKey = '', contextKey2 = '', contextKey3 = '', contextKey4 = '', contextKey5 = '', ...args) => {
    let _Data = {
        ...args,
        Source: "Web",
        LoginToken: getCookie('login_Token'),
        LoginUserCode: getCookie('login_User_Code'),
    }
    let dataList = [];
    try {
        if (prefix !== undefined && prefix !== '') {
            const abortController = new AbortController();
            const response = await fetch(`${API_SERVER}/api/AutoComplete/AutoComplete`, {
                method: 'POST',
                body: JSON.stringify({ ..._Data, type: type, prefix, contextKey: contextKey, contextKey2: contextKey2, contextKey3: contextKey3, contextKey4: contextKey4, contextKey5: contextKey5 }),
                headers: {
                    "Content-Type": "application/json"
                },
                signal: abortController.signal
            });

            const res = await response.json();

            let _datalist = res.autoCompleteData;
            for (let i = 0; i < _datalist?.length; i++) {
                let _value = (_datalist[i]?.values);
                dataList?.push(_value);
            }
            return dataList;
        }
        else {
            return [];
        }
    } catch (error) {
        console.error('Error fetching suggestions:', error);
        return [];
    }
};

export const handleDownloadExcel = async (handleApiUrl, FileName, request, enableAlternateColor = false, enableHeaderColor = true, enableFilters = false) => {

    try {
        let res = await ApiCall(handleApiUrl, { ...request })
        if (res.Status === "SUCCESS") {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet 1', {
                views: [{ state: 'frozen', ySplit: 1 }],
            });

            // Example: Set header row to bold and background color
            const headerRow = worksheet.addRow(res?.HeadersKey?.length > 0
                ? res.HeadersKey.filter((key) => {
                    return res?.HideColumns?.length > 0 ? !res?.HideColumns?.includes(key) : key
                })
                : Array.from(
                    new Set(
                        res?.Data?.flatMap((data) => Object.keys(data))
                            .filter((columnName) => !res?.HideColumns?.includes(columnName))
                    )
                ))

            const headerKey = (res?.HeadersKey?.length > 0 && res?.HeadersValue?.length > 0)
                ? res.HeadersValue.filter((key) => {
                    return res?.HideColumns?.length > 0 ? !res?.HideColumns?.includes(key) : key
                })
                : Array.from(
                    new Set(
                        res.Data?.flatMap((data) => Object.keys(data))
                            .filter((columnName) => !res?.HideColumns?.includes(columnName))
                    )
                );

            headerRow.font = { bold: true };
            if (enableHeaderColor) {
                headerRow.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFFF00' },
                };
                headerRow.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
            }

            // Example: Enable filters
            if (enableFilters) {
                worksheet.autoFilter = {
                    from: { row: 1, column: 1 },
                    to: { row: 1, column: headerKey.length },
                };
            }

            // Example: Set alternate row background color
            for (let i = 2; i <= res.Data.length + 1; i++) {
                const row = worksheet.getRow(i);

                if (enableAlternateColor && i % 2 === 0) {
                    row.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'DDDDDD' },
                    };
                }

                row.values = res.HeadersValue?.length > 0 ?
                    res.HeadersValue?.map((key) => res.Data[i - 2][key])
                    : headerKey?.map((key) => res.Data[i - 2][key]);
            }

            // Set column widths to fit content
            worksheet.columns.forEach((column) => {
                let maxLength = 0;
                column.eachCell({ includeEmpty: true }, (cell) => {
                    const length = cell.value ? String(cell.value).length : 0;
                    maxLength = Math.max(maxLength, length);
                });
                column.width = maxLength < 12 ? 12 : maxLength;
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const data = new Blob([buffer], { type: 'application/octet-stream' });
            const url = window.URL.createObjectURL(data);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${FileName}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } else {
            NotificationSound(res.Status, res.Message, res.focus)
        }
    } catch (err) {
        /* NotificationSound('ERROR', err.message)*/
    }
};




export const DropDownData = (Type, ContextKey = '', ContextKey2 = '') => {
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState({});
    let Data = {
        Source: "Web",
        LoginToken: getCookie('login_Token'),
        LoginUserCode: getCookie('login_User_Code'),
    };


    useEffect(() => {
        const getMasterData = async () => {
            const response = await ApiCall('/api/AutoComplete/GetMasterData', { ...Data, Type, ContextKey, ContextKey2 })
            if (response.status === 'SUCCESS') {
                const tempMap = response.dataList.map(ele => ({ ...ele, name: ContextKey === "false" ? ele.name : ele.name }))
                setData({ ...response, dataList: tempMap })
                setLoading(false)
            } else {
                setError('Error')
                setLoading(false)
            }
            //fetch(`${API_SERVER + '/api/AutoComplete/GetMasterData'}`, {
            //    method: 'POST',
            //    body: JSON.stringify({ ...Data, Type, ContextKey, ContextKey2 }),
            //    headers: {
            //        "Content-Type": "application/json"
            //    },
            //    signal: abortController.signal
            //}).then((res) => res.json())
            //    .then((res) => {
            //        const tempMap = res.dataList.map(ele => ({ ...ele, name: ContextKey === "false" ? ele.name : ele.name }))
            //        setData({ ...res, dataList: tempMap })
            //        setLoading(false)
            //    })
            //    .catch((err) => {
            //        setError(err)
            //        setLoading(false)
            //    })
            //    .finally(() => {
            //        abortController.abort();
            //    });
        }
        getMasterData()
    }, [Type, ContextKey, ContextKey2])
    return { data, error, loading };
};

export const BindDropDownList = (TableName ='', TextPart='', ValuePart='', Condition='') => {
    const [data, setData] = useState({});

    let Data = {
        LoginToken: getCookie('login_Token'),
        LoginUserCode: getCookie('login_User_Code'),
        TableName: TableName,
        TextPart: TextPart,
        ValuePart: ValuePart,
        Condition: Condition,
    }

    useEffect(() => {
     
        const abortController = new AbortController();

        fetch(`${API_SERVER}/api/User/BindDropDownList`, {
            method: 'POST',
            body: JSON.stringify({ ...Data }),
            headers: {
                "Content-Type": "application/json"
            },
            signal: abortController.signal
        }).then((res) => res.json())
            .then((res) => {
                setData(res)
            })
            .catch((err) => {
                NotificationSound('Error', err)
            })
            .finally(() => {
                abortController.abort();
            });
            
    }, [TableName, TextPart, ValuePart, Condition])
    return { data };
};

export const BindMultiDropDownList = (TableName ='', TextPart='', ValuePart='', Condition='') => {
    const [data, setData] = useState({});

    let Data = {
        LoginToken: getCookie('login_Token'),
        LoginUserCode: getCookie('login_User_Code'),
        TableName: TableName,
        TextPart: TextPart,
        ValuePart: ValuePart,
        Condition: Condition,
    }

    useEffect(() => {
     
        const abortController = new AbortController();

        fetch(`${API_SERVER}/api/Dashboard/MultiSelectList`, {
            method: 'POST',
            body: JSON.stringify({ ...Data }),
            headers: {
                "Content-Type": "application/json"
            },
            signal: abortController.signal
        }).then((res) => res.json())
            .then((res) => {
                setData(res)
            })
            .catch((err) => {
                NotificationSound('Error', err)
            })
            .finally(() => {
                abortController.abort();
            });
            
    }, [TableName, TextPart, ValuePart, Condition])
    return { data };
};


export const setCookie = (name, value, days) => {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

export const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
};

export const deleteCookie = (name) => {
    setCookie(name, "", -1);
};


export const setFocus = (ID) => {
    const element = document.getElementById(ID);
    if (element) {
        element.focus()
    }
}

export const dateFormate = (e) => {
    let dateArr = (e?.toString() || '').split(' ');
    if (dateArr.length >= 4) {
        dateArr = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`;
        return dateArr
    } else {
        return dateArr = '';
    }
}

export const currentDate = () => {
    const forBeforeDays = new Date();
    return dateFormate(forBeforeDays);
};

export const getBeforeDate = (lastDay = 7, today = new Date()) => {
    const forBeforeDays = new Date();
    forBeforeDays.setDate(today.getDate() - lastDay);
    return dateFormate(forBeforeDays);
};

export const getAfterDate = (afterDay = 7, today = new Date()) => {
    const forBeforeDays = new Date();
    forBeforeDays.setDate(today.getDate() + afterDay);
    return dateFormate(forBeforeDays);
};



export function ConvertToBlobPDF(value, newWindow = false) {
    const binStr = atob(value);
    const len = binStr.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
    }

    let pdfBlob = new Blob([arr], { type: 'application/pdf' });
    const url = URL.createObjectURL(pdfBlob);
    sessionStorage.setItem('pdfBlobUrl', url);
    newWindow ?
        window.open(`${virtualPath}/PDFView`, 'PDFWindow', 'width=800,height=600,scrollbars=yes,resizable=yes') :
        window.open(`${virtualPath}/PDFView`, '_blank')

}

export function ConvertToBlobImage(value, newWindow = false) {
    // Convert base64-encoded string to binary string
    const binStr = atob(value);
    const len = binStr.length;
    // Create a Uint8Array to hold the binary data
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);

    }
    // Create a Blob object from the binary array, specifying the image MIME type
    const imageBlob = new Blob([arr], { type: 'image/png' });
    // Generate a URL for the Blob and store it in sessionStorage
    const url = URL.createObjectURL(imageBlob);
    sessionStorage.setItem('imageBlobUrl', url);
    // Open a new window or tab based on the 'newWindow' flag
    if (newWindow) {
        window.open(virtualPath + '/ImageView', 'ImageWindow', 'width=800,height=600,scrollbars=yes,resizable=yes');
    } else {
        window.open(virtualPath + '/ImageView', '_blank');

    }

}

export const parseDate = (dateStr) => dayjs(dateStr).format("DD-MMM-YYYY");
export const formatDate = (dateStr) => dayjs(dateStr, "DD-MMM-YYYY");



//export const handleDateChange = (e, setFormData, formData, key) => {
//    let dateArr = (e?.toString() || '').split(' ');
//    if (dateArr.length >= 4) {
//        dateArr = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`;
//        setFormData({ ...formData, [key]: dateArr });
//    } else {
//        setFormData({ ...formData, [key]: '' });
//    }
//};


export const handleDateChange = (date, setFormData, formData, key) => {
    if (date) {
        const day = String(date.getDate()).padStart(2, "0");
        const month = date.toLocaleString("en-US", { month: "short" });
        const year = date.getFullYear();
        const formatted = `${day}-${month}-${year}`; // e.g. 29-Aug-2025
        setFormData({ ...formData, [key]: formatted });
    } else {
        setFormData({ ...formData, [key]: "" });
    }
};

export function getCurrentTime() {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
}

export const validateTimeFormat = (time) => {
    const regex = /^([0-9]{2}):([0-9]{2})$/;
    return regex.test(time);
};

export function convertToAlphabet(value) {
    return value.replace(/[^a-z | A-Z]/g, '');
}

export function convertToAlphaNum(value) {
    return value.replace(/[^a-zA-Z0-9 ]/g, '');
}

export function convertToNumber(value) {
    return value.replace(/[^0-9]/g, '');
}

export function convertToNumberWithDot(value, digitAfterDot = 2) {
    let result = value.replace(/[^0-9.]/g, '');

    const firstDotIndex = result.indexOf('.');
    if (firstDotIndex !== -1) {
        const beforeDot = result.slice(0, firstDotIndex + 1);
        const afterDot = result.slice(firstDotIndex + 1).replace(/\./g, '');
        result = beforeDot + afterDot.slice(0, digitAfterDot);
    }

    return result;
}




export const NotificationSound = (status = '', message = '', focus = '', handleClear = null) => {
    const BroadcastMsg = (Key, Value) => {
        if (typeof BroadcastChannel !== 'undefined') {
            const broadcastChannel = new BroadcastChannel(virtualPath.replace("/", "-") + 'broadcast_channel');
            broadcastChannel.postMessage({ Key, Value });
        }
    };

    if (status.trim().toUpperCase() === 'EXPIRED') {
        (async () => {
            await deleteCookie('login_Token')
            await deleteCookie('login_User_Code')
            window.location.href = '/';
        })()
        return
    }

    const obj_status = {
        'ERROR': {
            position: "center",
            icon: 'error',
            title: 'Oops..',
            color: '#dc362e',
            sound: './Sound/Error.mp3',
        },
        'UNAUTHORIZED': {
            icon: 'error',
            title: 'UNAUTHORIZED',
            color: '#dc362e',
            sound: './Sound/Error.mp3',
        },
        'SUCCESS': {
            icon: 'success',
            title: 'Success',
            color: '#238914',
            sound: './Sound/Success.mp3',
        },
        'INFO': {
            icon: 'info',
            title: 'Information',
            color: '#2b6274',
            sound: './Sound/Success.mp3',
        },
        'INITIATED': {
            icon: 'initiated',
            title: 'Initiated',
            color: '#eab308',
            sound: './Sound/Success.mp3',
        },
        'In Process': {
            icon: 'initiated',
            title: 'In Process',
            color: '#eab308',
            sound: './Sound/Success.mp3',
        },
    };
    const obj_position = {
        'top': 'top',
        'top start': 'top-start',
        'top end': 'top-end',
        'center': 'center',
        'center start': 'center-start',
        'center end': 'center-end',
        'bottom': 'bottom',
        'bottom start': 'bottom-start',
        'bottom end': 'bottom-end',
    };
    let enableNotificationSound = false;
    let _toast = false;
    let timer = 0;
    let position = obj_position?.center?.position;
    let width = 500;

    const { icon, title, color, sound } = obj_status[status.toUpperCase()] || obj_status.ERROR;

    if (_toast) {
        timer = 3000;
        width = 450;
    }
    const options = {
        position: 'center',
        toast: _toast,
        text: message || title,
        icon,
        title: (_toast ? null : title),
        color,
        confirmButtonColor: color,
        timerProgressBar: _toast,
        showConfirmButton: !_toast,
        iconColor: color,
        timer: timer,
        width: width,
        didOpen: (toast) => {
            if (_toast) {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
                //toast.addEventListener('click', () => Swal.close())

                if (status.trim().toUpperCase() === 'SUCCESS') {
                    if (handleClear !== null && focus !== '') {
                        handleClear()
                    }
                }
                if (focus !== '') {
                    setFocus(focus)
                }
            }
        },
        didClose: () => {
            if (!_toast) {
                if (status.trim().toUpperCase() === 'SUCCESS') {
                    if (handleClear !== null && focus !== null) {
                        handleClear()
                    }
                }
                if (focus !== '') {
                    setFocus(focus)
                }
            }
            if (status.trim().toUpperCase() === 'EXPIRED') {
                (async () => {
                    await deleteCookie('login_Token')
                    await deleteCookie('login_User_Code')
                    window.location.href = '/';
                })()
            }
        },
        showClass: {
            popup: 'animate__animated animate__fadeInUp animate__faster',
        },
        hideClass: {
            popup: 'animate__animated animate__fadeOutDown animate__faster',
        },
    };

    Swal.fire(options).then((result) => {
        if (result.isConfirmed) {
            if (status.trim().toUpperCase() === 'SUCCESS') {
                if (handleClear !== null && focus !== null) {
                    handleClear()
                }
            }
            if (focus !== '') {
                setFocus(focus)
            }
        }
    });


    return;
}


export const ConfirmAlertBox = (status = '', message = '', callback, focusElementId = '',) => {
    if (message !== undefined && message !== "") {
        Swal.fire({
            text: message,
            icon: status.toLowerCase(),
            title: status.toUpperCase(),
            confirmButtonColor: '#238914',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
            cancelButtonText: 'Cancel',
            showCancelButton: true,
            allowOutsideClick: false,
            width: 500,
            didClose: () => {
                if (focusElementId !== "")
                    document.getElementById(focusElementId)?.focus();
            }
        }).then((result) => {
            if (result.isConfirmed) {
                callback(result.isConfirmed);
            } else if (result.isDismissed) {
                callback(false);

            }
        });
        // alert(FindTranslatedKey(message))
    }
}


//..........Common Table Design for Website..........

//<div className="mt-5 rounded-xl border bg-white p-3">
//    <table className="common-table">
//        <thead>
//            <tr>
//                <th>Sr No.</th>
//                <th>Phone Number</th>
//                <th>Personal Information</th>
//                <th>Aadhaar Authenticate</th>
//                <th>Bank Details</th>
//                <th>Bank Authenticate</th>
//                <th>Completion</th>
//                <th>Action</th>
//            </tr>
//        </thead>
//        <tbody>
//            <tr>
//                <td className='text-sm font-normal text-zinc-700'>01</td>
//                <td className='text-sm font-normal text-zinc-700'>00000 00000</td>
//                <td className='text-sm font-normal text-zinc-700'>Filled</td>
//                <td className='text-sm font-normal text-red-500'>Failed</td>
//                <td className='text-sm font-normal text-zinc-700'>Not Filled</td>
//                <td className='text-sm font-normal text-zinc-700'>Not Filled</td>
//                <td>
//                    <div className='flex items-center gap-1'>
//                        <div className="h-2.5 w-full rounded-full bg-red-200">
//                            <div className="h-2.5 w-[25%] rounded-full bg-red-600"></div>
//                        </div>
//                        <div className='text-sm text-zinc-700'>25%</div>
//                    </div>
//                </td>
//                <td className='text-center'>
//                    <button>
//                        <i className="fa-solid fa-trash-can text-red-500"></i>
//                    </button>
//                </td>
//            </tr>
//            <tr>
//                <td className='text-sm font-normal text-zinc-700'>02</td>
//                <td className='text-sm font-normal text-zinc-700'>00000 00000</td>
//                <td className='text-sm font-normal text-zinc-700'>Filled</td>
//                <td className='text-sm font-normal text-green-500'>Succes</td>
//                <td className='text-sm font-normal text-zinc-700'>Filled</td>
//                <td className='text-sm font-normal text-red-500'>Failed</td>
//                <td>
//                    <div className='flex items-center gap-1'>
//                        <div className="h-2.5 w-full rounded-full bg-yellow-100">
//                            <div className="h-2.5 w-[50%] rounded-full bg-yellow-400"></div>
//                        </div>
//                        <div className='text-sm text-zinc-700'>50%</div>
//                    </div>
//                </td>
//                <td className='text-center'>
//                    <button>
//                        <i className="fa-solid fa-trash-can text-red-500"></i>
//                    </button>
//                </td>
//            </tr>
//            <tr>
//                <td className='text-sm font-normal text-zinc-700'>03</td>
//                <td className='text-sm font-normal text-zinc-700'>00000 00000</td>
//                <td className='text-sm font-normal text-zinc-700'>Filled</td>
//                <td className='text-sm font-normal text-red-500'>Failed</td>
//                <td className='text-sm font-normal text-zinc-700'>Not Filled</td>
//                <td className='text-sm font-normal text-zinc-700'>Not Filled</td>
//                <td>
//                    <div className='flex items-center gap-1'>
//                        <div className="h-2.5 w-full rounded-full bg-red-200">
//                            <div className="h-2.5 w-[25%] rounded-full bg-red-600"></div>
//                        </div>
//                        <div className='text-sm text-zinc-700'>25%</div>
//                    </div>
//                </td>
//                <td className='text-center'>
//                    <button>
//                        <i className="fa-solid fa-trash-can text-red-500"></i>
//                    </button>
//                </td>
//            </tr>
//            <tr>
//                <td className='text-sm font-normal text-zinc-700'>04</td>
//                <td className='text-sm font-normal text-zinc-700'>00000 00000</td>
//                <td className='text-sm font-normal text-zinc-700'>Filled</td>
//                <td className='text-sm font-normal text-red-500'>Failed</td>
//                <td className='text-sm font-normal text-zinc-700'>Not Filled</td>
//                <td className='text-sm font-normal text-zinc-700'>Not Filled</td>
//                <td>
//                    <div className='flex items-center gap-1'>
//                        <div className="h-2.5 w-full rounded-full bg-red-200">
//                            <div className="h-2.5 w-[25%] rounded-full bg-red-600"></div>
//                        </div>
//                        <div className='text-sm text-zinc-700'>25%</div>
//                    </div>
//                </td>
//                <td className='text-center'>
//                    <button>
//                        <i className="fa-solid fa-trash-can text-red-500"></i>
//                    </button>
//                </td>
//            </tr>
//        </tbody>
//    </table>
//</div>